module.exports = __webpack_public_path__ + "img/marche.0a954463.png";